// src/learn/mdxComponents.tsx
import React from 'react';
import FaqSchema from './FaqSchema';

const heading = 'text-[#102033] dark:text-[#fffaf0]';
const body = 'text-slate-700 dark:text-white/82';
const link = 'text-cyan-700 dark:text-cyan-200 underline underline-offset-4 decoration-2 decoration-cyan-400/60 hover:opacity-80';

export const mdxComponents = {
  h1: (props: any) => (
    <h1 className={`mb-4 text-4xl font-black leading-tight tracking-tight sm:text-5xl ${heading}`} {...props} />
  ),
  h2: (props: any) => (
    <h2 className={`mb-3 mt-9 text-2xl font-black leading-tight tracking-tight sm:text-3xl ${heading}`} {...props} />
  ),
  h3: (props: any) => (
    <h3 className={`mb-2 mt-7 text-xl font-extrabold leading-tight ${heading}`} {...props} />
  ),
  p: (props: any) => <p className={`mb-4 text-base font-semibold leading-8 ${body}`} {...props} />,
  ul: (props: any) => <ul className={`mb-5 list-disc space-y-2 pl-6 text-base font-semibold leading-8 ${body}`} {...props} />,
  ol: (props: any) => <ol className={`mb-5 list-decimal space-y-2 pl-6 text-base font-semibold leading-8 ${body}`} {...props} />,
  li: (props: any) => <li className="marker:text-emerald-500" {...props} />,
  a: (props: any) => (
    <a
      {...props}
      className={link}
      rel={props?.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
      target={props?.href?.startsWith('http') ? '_blank' : undefined}
    />
  ),
  hr: (props: any) => <hr className="my-8 border-slate-900/10 dark:border-white/12" {...props} />,
  blockquote: (props: any) => (
    <blockquote
      className="my-5 rounded-2xl border-l-4 border-emerald-400 bg-emerald-50/80 px-5 py-4 text-slate-800 dark:bg-emerald-400/10 dark:text-emerald-50"
      {...props}
    />
  ),
  code: (props: any) => (
    <code
      className="rounded-md bg-slate-900/10 px-1.5 py-0.5 text-[0.9em] font-bold text-slate-900 dark:bg-white/12 dark:text-white"
      {...props}
    />
  ),
  pre: (props: any) => (
    <pre
      className="mb-5 overflow-auto rounded-2xl bg-slate-950 p-4 text-sm font-semibold text-slate-50 shadow-inner"
      {...props}
    />
  ),
  table: (props: any) => (
    <div className="my-6 overflow-x-auto rounded-2xl border border-slate-900/10 dark:border-white/10">
      <table className="w-full min-w-[560px] text-left text-sm" {...props} />
    </div>
  ),
  th: (props: any) => (
    <th className="bg-slate-900/5 px-4 py-3 font-black text-slate-900 dark:bg-white/10 dark:text-white" {...props} />
  ),
  td: (props: any) => <td className="border-t border-slate-900/10 px-4 py-3 text-slate-700 dark:border-white/10 dark:text-white/80" {...props} />,
  FaqSchema,
};
